import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

class ShowPagoInfo extends Component {

  render() {
    const { data } = this.props;

    return (
      <>
        <Row>
          <Col>
            <br /><strong>RFC: </strong> { data.Receptor?.rfc }
            <br /><strong>Razón social: </strong>{ data.Receptor?.razon_social }</Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <strong>Pagos realizados: </strong> { data.Factoraje?.Pagos }
            <br />

            <strong>Monto Pagado: </strong> { data.Factoraje?.ImportePagado }
            <br />

            <strong>Monto Pendiente: </strong> { data.Factoraje?.ImporteSaldoInsoluto }
            <br />
          </Col>
          <Col>
            <strong>Serie: </strong> { data.Serie }
            <br />

            <strong>Folio: </strong> { data.Folio }
            <br />

            <strong>Moneda: </strong> { data.Moneda }
            <br />

            <strong>Tipo de Cambio: </strong> { data.TipoCambio }
            <br />
          </Col>
        </Row>
      </>
    )
  }
}

export default ShowPagoInfo;